import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nestflow-shop/artifacts/2puqgfry_image_2026-04-26_175646054.png";

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { cartCount, setIsCartOpen } = useCart();
  const navigate = useNavigate();

  const goHome = (e) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/40"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="/" 
            onClick={goHome}
            className="flex items-center gap-0 flex-shrink-0"
            data-testid="logo-link"
          >
            <img 
              src={LOGO_URL} 
              alt="NestFlow" 
              className="h-10 sm:h-11 object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            <a 
              href="/" 
              onClick={goHome}
              className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium"
              data-testid="nav-home"
            >
              Home
            </a>
            <Link 
              to="/products" 
              className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium"
              data-testid="nav-products"
            >
              Products
            </Link>
            <a 
              href="/#benefits" 
              className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium"
              data-testid="nav-benefits"
            >
              Benefits
            </a>
            <a 
              href="/#reviews" 
              className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium"
              data-testid="nav-reviews"
            >
              Reviews
            </a>
          </nav>

          {/* Cart Button */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/cart')}
              className="relative p-2 hover:bg-[#F3F2EE] rounded-full transition-colors"
              data-testid="cart-button"
              aria-label="Open cart"
            >
              <ShoppingBag className="w-6 h-6 text-[#1A1A1C]" strokeWidth={1.5} />
              {cartCount > 0 && (
                <span 
                  className="absolute -top-1 -right-1 bg-[#1A1A1C] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium"
                  data-testid="cart-count"
                >
                  {cartCount}
                </span>
              )}
            </button>

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden p-2 hover:bg-[#F3F2EE] rounded-full transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className="w-6 h-6 text-[#1A1A1C]" strokeWidth={1.5} />
              ) : (
                <Menu className="w-6 h-6 text-[#1A1A1C]" strokeWidth={1.5} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav 
            className="md:hidden mt-4 py-4 border-t border-[#E5E5E5] animate-fade-in"
            data-testid="mobile-nav"
          >
            <div className="flex flex-col gap-4">
              <a 
                href="/" 
                className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium py-2"
                onClick={(e) => { setIsMobileMenuOpen(false); goHome(e); }}
              >
                Home
              </a>
              <Link 
                to="/products" 
                className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Products
              </Link>
              <a 
                href="/#benefits" 
                className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Benefits
              </a>
              <a 
                href="/#reviews" 
                className="text-[#5C5C60] hover:text-[#1A1A1C] transition-colors font-medium py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Reviews
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
